import { IPriceTypeFilterModel, priceRangeModel } from '../filter/reducers/filter-reducers';
import { PriceType } from '../classes/price-type';
import { orderBy, reduce, uniqBy, find, sortBy } from 'lodash';
import { SeatPricing } from '../classes/seat';

export function getSelectedTicketCount(priceTypesFilterModel: IPriceTypeFilterModel) {
    return reduce(priceTypesFilterModel.priceTypes, (sum, n) => sum + n.selectedQuantity, 0);
}

export function getSelectedPriceTypes(priceTypeFilterModel: IPriceTypeFilterModel): Array<PriceType> {
    if (priceTypeFilterModel.priceTypes.length === 1) {
        return [priceTypeFilterModel.priceTypes[0]];
    }
    return priceTypeFilterModel.priceTypes.filter(pt => pt.selectedQuantity > 0);
}

export function findDefaultPriceType(priceTypes: Array<PriceType>, useOnlyPromoPriceType: boolean): PriceType {
    if (priceTypes !== undefined && priceTypes.length > 0) {
        let defaultPriceType = find(priceTypes, 'isDefault');

        if (defaultPriceType === undefined && priceTypes.length > 0) {
            defaultPriceType = priceTypes[0];
        }

        //need a prop to turn on if promo price types are there, then choose promo as default price type
        if (useOnlyPromoPriceType) {
            let promoPriceTypes = priceTypes.filter(pt => pt.isPromo);
            if (promoPriceTypes.length > 0) {
                defaultPriceType = sortBy(promoPriceTypes, 'minPrice')[0]
            }
        }

        return defaultPriceType as PriceType;
    }
    return null;
}

export function sortPriceTypes(priceTypes: PriceType[]): PriceType[] {
    return orderBy(priceTypes,
        [(pt => pt.isDefault),
        (pt => pt.order > 0),
        (pt => pt.order)],
        ['desc', 'desc', 'asc']);
}

export function sortSeatPricing(seatPricing: SeatPricing[]): SeatPricing[] {
    return orderBy(seatPricing,
        [(pt => pt.isDefault),
        (pt => pt.order > 0),
        (pt => pt.order)],
        ['desc', 'desc', 'asc']);
}